import { admin, db } from "common/config/Firebase";
import createIds from "./createIds";

const indicatorsByMonth = db.collection('indicatorsByMonth')

const addTask = ({ task }) => {
    incrementNumberTask(new Date(task.dateEntry), 0, 1)
}

const updateTask = ({ task, oldTask}) => {
    if (!isReparado(task) && !isReparado(oldTask)) {
        return
    }

    let incrementComplete = 0;
    let incrementIncomplete = 0;

    if (isReparado(task) && !isReparado(oldTask)) {
        incrementComplete = 1
        incrementIncomplete = -1
    }

    else if (!isReparado(task) && isReparado(oldTask)) {
        incrementComplete = -1
        incrementIncomplete = 1
    }

    incrementNumberTask(new Date(task.dateEntry), incrementComplete, incrementIncomplete)
}

const deleteTask = ({ task }) => {
    if (!isReparado(task)) {
        incrementNumberTask(new Date(task.dateEntry), 0, -1)
        return
    }

    incrementNumberTask(new Date(task.dateEntry), -1, 0)
}

const isReparado = task => {
    return Number(task.state) === 2
}

const incrementNumberTask = (date, incrementComplete, incrementIncomplete) => {
    const incrementCompleteFB = admin.firestore.FieldValue.increment(incrementComplete)
    const incrementIncompleteFB = admin.firestore.FieldValue.increment(incrementIncomplete)

    try {
        indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ numberTaskComplete: incrementCompleteFB, numberTaskIncomplete: incrementIncompleteFB }, { merge: true })
    } catch (ex) {
        console.error("Error al actualizar el indicatorsByDay")
    }
}

export default {
    addTask,
    updateTask,
    deleteTask
}